var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStrikeBellcomponent = function SvgStrikeBellcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 8.25c0-2.303-1.23-4.23-3.375-4.74V3c0-.623-.502-1.125-1.125-1.125S7.875 2.377 7.875 3v.51a4.28 4.28 0 0 0-.439.144l-.079.029L13.5 9.825V8.25ZM9 16.5c.825 0 1.5-.675 1.5-1.5h-3A1.5 1.5 0 0 0 9 16.5ZM5.107 5.678 3 3.57l1.058-1.057 11.985 11.985-1.058 1.057-1.305-1.305H3v-.75L4.5 12V8.25c0-.952.218-1.822.607-2.572Z",
    fill: "current"
  })));
};
export default SvgStrikeBellcomponent;